/*
  Reliable "open the cart drawer on add-to-cart" for all add paths.

  The theme's product-form already re-renders + opens the drawer, but its open()
  runs inside nested setTimeouts and can be missed. This subscribes to the
  cartUpdate pubsub event (published by product-form.js AND bundle-builder.js on a
  successful add) and explicitly opens the drawer — idempotent with the theme's own
  open(), so it just guarantees the drawer slides in. Skips cart-page qty edits.
*/
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) {
      return;
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      // Don't auto-open from quantity changes made inside the cart drawer/page.
      if (event && (event.source === 'cart-items' || event.source === 'cart-note')) return;
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.open !== 'function') return;
      // Run after the theme finishes patching the drawer contents.
      requestAnimationFrame(function () {
        if (!drawer.classList.contains('active')) drawer.open();
      });
    });
  });
})();
